const tr = {
    nav: {
      home: "Ana Sayfa",
      browse: "Düğünleri Keşfet",
      dashboard: "Panel",
      messages: "Mesajlar",
      profile: "Profil",
      login: "Giriş Yap",
      register: "Kayıt Ol",
      logout: "Çıkış Yap",
      admin: "Yönetici",
      faq: "SSS",
      about: "Hakkımızda",
      contact: "İletişim",
      pricing: "Fiyatlandırma",
      howItWorks: "Nasıl Çalışır",
    },
    auth: {
      login: {
        title: "Tekrar Hoşgeldiniz",
        email: "E-posta",
        password: "Şifre",
        button: "Giriş Yap",
        noAccount: "Hesabınız yok mu?",
        register: "Şimdi kaydolun",
      },
      register: {
        title: "Hesap Oluştur",
        name: "Tam Ad",
        email: "E-posta",
        password: "Şifre",
        role: "İstiyorum...",
        roleHost: "Düğün düzenlemek",
        roleGuest: "Düğünlere katılmak",
        terms: "Şartları ve gizlilik politikasını kabul ediyorum",
        button: "Kayıt Ol",
        hasAccount: "Zaten hesabınız var mı?",
        login: "Şimdi giriş yapın",
      },
    },
  review: {
    title: "Write a Review",
    description: "Share your experience with",
    ratingLabel: "How would you rate your experience?",
    rating1: "Poor",
    rating2: "Fair",
    rating3: "Good",
    rating4: "Very Good",
    rating5: "Excellent",
    commentLabel: "Your Review",
    optional: "optional",
    commentPlaceholder: "Tell others about your experience...",
    for: "Review for",
    submit: "Submit Review",
    success: "Review submitted successfully!",
    error: "Failed to submit review",
    selectRating: "Please select a rating",
    noReviews: "No reviews yet",
    received: "Reviews Received",
    averageRating: "Average Rating",
    writeReview: "Write Review",
    reviewed: "Reviewed",
    completedWedding: "This wedding has been completed. You can now write a review.",
  },

    common: {
      loading: "Yükleniyor...",
      error: "Bir hata oluştu",
      success: "Başarılı",
      save: "Kaydet",
      cancel: "İptal",
      delete: "Sil",
      edit: "Düzenle",
      back: "Geri",
      next: "İleri",
      language: "Dil",
      currency: "Para Birimi",
      search: "Ara",
      filter: "Filtrele",
      all: "Tümü",
      none: "Hiçbiri",
      yes: "Evet",
      no: "Hayır",
    },
    footer: {
      about: "Hakkımızda",
      privacy: "Gizlilik",
      terms: "Şartlar",
      contact: "İletişim",
      copyright: "© 2024 WEDVAYA. Tüm hakları saklıdır.",
    },
  };

export default tr;
